import { GlobalContext } from "@/contexts";
import { SearchParamType } from "@/types/SearchParamType";
import { useContext, useLayoutEffect, useRef } from "react";
/**
 * Hook that ensures the current country is always present in the URL
 * This runs only once on initial load to avoid triggering additional queries
 */
export var useEnsureCountryInUrl = function () {
    var countryConfig = useContext(GlobalContext).countryConfig;
    var hasInitialized = useRef(false);
    useLayoutEffect(function () {
        // Only run once to avoid interfering with other URL updates
        if (hasInitialized.current)
            return;
        var currentUrl = new URL(window.location.href);
        var params = new URLSearchParams(currentUrl.search);
        var countryFromUrl = params.get(SearchParamType.COUNTRY);
        var defaultCountry = countryConfig.selectedCountry;
        // If no country in URL but we have a default country, add it
        if (!countryFromUrl && defaultCountry) {
            params.set(SearchParamType.COUNTRY, defaultCountry);
            // Update URL using native History API to avoid React Router re-renders
            var newUrl = "".concat(currentUrl.pathname, "?").concat(params.toString()).concat(currentUrl.hash);
            window.history.replaceState(null, "", newUrl);
        }
        hasInitialized.current = true;
    }, []); // Empty dependency array to run only once
};
